import Container, { ContainerProps } from '@material-ui/core/Container';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled(Container)`
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: 60px;
  min-height: 100vh;
  width: 100%;
  @media (min-width: 600px) {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  @media (min-width: 960px) {
    padding-top: 32px;
    padding-bottom: 32px;
  }
` as React.ComponentType<ContainerProps>;
const Layout: React.FC<{ noMarginTop?: boolean; maxWidth?: string; style?: any }> = ({ children, maxWidth, style = {}, noMarginTop }) => {
  return (
    <Wrapper style={{ ...style, marginTop: noMarginTop ? 0 : undefined }} maxWidth={(maxWidth as any) || 'xl'}>
      {children}
    </Wrapper>
  );
};

export default Layout;
